// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import './styles.scss';
import { GUIDE } from '../../../../assets/imgs';

function TopTitleKuzipa() {
  return (
    <div className="top-guide">
      <img src={GUIDE.imgTopGuide} className="img-top-guide" />
    </div>
  );
}

export default TopTitleKuzipa;
